import * as m from "../../model/model";

import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Workspace } from "../../model/model";

export interface WorkspaceState {
  workspaces: Workspace[];
  currentWorkspace: Workspace | null;
}

const initialState: WorkspaceState = {
  workspaces: [],
  currentWorkspace: null,
};

const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    setWorkspaces: (state, action: PayloadAction<Workspace[]>) => {
      state.workspaces = action.payload;
    },
    setCurrentWorkspace: (state, action: PayloadAction<Workspace | null>) => {
      state.currentWorkspace = action.payload;
    },
    addUser: (state, action: PayloadAction<m.FbUser>) => {
      if (!state.currentWorkspace) return;
      const workspaceUser: m.WorkspaceUser = {
        id: action.payload.key,
        email: action.payload.email,
        role: "user",
        name: action.payload.name,
      };
      if (!state.currentWorkspace.users) {
        state.currentWorkspace.users = [];
      }
      state.currentWorkspace.users.push(workspaceUser);
    },
  },
});

export const workspaceActions = workspaceSlice.actions;
export default workspaceSlice.reducer;
